import React from 'react';
import { Chip } from '@mui/material';
import { API_URL } from '../../Utils/url';

export const FONT = 'Mulish, sans-serif';

export const STATE = {
  live: { label: 'Live', bg: '#dcfce7', fg: '#166534', accent: '#22c55e' },
  scheduled: { label: 'Scheduled', bg: '#dbeafe', fg: '#1e40af', accent: '#3b82f6' },
  expired: { label: 'Expired', bg: '#fee2e2', fg: '#991b1b', accent: '#ef4444' },
  inactive: { label: 'Inactive', bg: '#f1f5f9', fg: '#475569', accent: '#94a3b8' },
};

// the server sends `state`; fall back to working it out for older responses
export const stateOf = (b) => {
  if (b?.state) return b.state;
  const now = new Date();
  if (!b?.isActive) return 'inactive';
  if (b.startDate && new Date(b.startDate) > now) return 'scheduled';
  if (b.endDate && new Date(b.endDate) < now) return 'expired';
  return 'live';
};

export const StateChip = ({ state }) => {
  const s = STATE[state] || STATE.inactive;
  return <Chip size="small" label={s.label} sx={{ fontFamily: FONT, fontWeight: 700, height: 22, background: s.bg, color: s.fg }} />;
};

export const authToken = () => {
  const raw = sessionStorage.getItem('token');
  return raw ? `Bearer ${raw}` : '';
};

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const period = (b) => (!b.startDate && !b.endDate ? 'Always on' : `${b.startDate ? fmtDate(b.startDate) : 'Any time'} → ${b.endDate ? fmtDate(b.endDate) : 'No end'}`);

// "Buy 2, get 1 at 100% off"
export const summary = (b) => {
  const d = Number(b.discountPercentage ?? 100);
  return `Buy ${b.buyQuantity}, get ${b.getQuantity} ${d >= 100 ? 'free' : `at ${d}% off`}`;
};

export const itemInfo = (item) => {
  const p = item?.product_id;
  const c = item?.category_id;
  if (p && typeof p === 'object') return { id: p._id, kind: 'Product', name: p.title || 'Product', image: imageUrl(p.product_images?.[0]), stock: p.availableQuantity, price: p.b2c_sellingPrice, mrp: p.b2c_mrp, code: p.productCode };
  if (c && typeof c === 'object') return { id: c._id, kind: 'Category', name: c.name || c.title || 'Category' };
  return null;
};

export const imageUrl = (path) => {
  if (!path) return undefined;
  return path.startsWith('http') || path.startsWith('blob:') ? path : `${API_URL.replace(/\/api\/?$/, '/')}${path.replace(/^\//, '')}`;
};

export const yellowBtn = { textTransform: 'none', fontWeight: 800, background: 'rgb(255 209 2)', color: 'black', borderRadius: '10px', px: 3, boxShadow: '0 4px 12px rgba(255, 209, 2, 0.3)', '&:hover': { background: 'rgb(255 190 0)' }, '&.Mui-disabled': { background: '#f1f5f9', color: '#94a3b8', boxShadow: 'none' } };
